<template>
	<div :class="['tt-btn', type]">
		<div class="btn-name">
			<span>{{text}}</span>
			<slot name="icon"></slot>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		text: {
			type: String,
			default: '保存'
		},
		type: {
			type: String,
			default: 'primary'
		}
	},
	data () {
		return {

		}
	}
}
</script>
<style lang="less" scoped>
	.tt-btn	 {
		width: 14.5rem;
		height: 2rem;
		line-height: 2rem;
		font-size: 16px;
		text-align: center;
		color: #fff;
		background: linear-gradient(180deg, #6D8BFF 0%, #557AFE 100%);
		border-radius:5px;
		border-radius: 1rem;
		margin: 0 auto;
		.btn-name {
			display: inline-block;
			position: relative;
			height: 2rem;
			line-height: 2rem;
			color: #fff;
			font-size: 16px;
		}
	}
	.active{
		background:#ccc;
	}
	.disabled {
		background: #D8D8D8;
	}
	.default {
		background: #fff;
		font-size: .8rem;
		.btn-name {
			color: #006EEF;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/ttButton.vue